import React, { createContext, useContext, ReactNode } from 'react';

type Theme = {
  colors: {
    primary: string;
    secondary: string;
    background: string;
    text: string;
    menutext: string;
    detailtext: string;
    surface: string;
    error: string;
    surfaceCard: string;
  };
  typography: {
    fontFamily: string;
    headingFontFamily: string;
    fontWeightRegular: number;
    fontWeightMedium: number;
    fontWeightBold: number;
    fontSize: number;
    h1: { fontSize: string };
    h2: { fontSize: string };
    h3: { fontSize: string };
    h4: { fontSize: string };
    h5: { fontSize: string };
    h6: { fontSize: string };
  };
  spacing: {
    unit: number;
  };
  borders: {
    radius: string;
    width: string;
    color: string;
    greenBorder: string;
    greyBorder: string;
  };
};
// default_theme.js
const defaultTheme: Theme  = {
  colors: {
    primary: '#7D532B',  // Primary color (e.g., primary brown)
    secondary: '#ffffff', // Secondary color (e.g., white)
    background: '#FFFEF7', // Background color
    text: '#000000',      // Text color
    menutext:'#ffffff', // Menu text color
    detailtext:' #5A6178',
    surface:'#102A83',   // Surface color for cards, buttons, etc.
    surfaceCard:'#F9F7ED',
    error: '#b00020',     // Error color
  },
  typography: {
    fontFamily: '"Nunito", sans-serif', // Font family
    headingFontFamily: '"Barlow", serif', // Heading font
    fontWeightRegular: 400,  // Regular font weight
    fontWeightMedium: 500,   // Medium font weight
      fontWeightBold: 800,     // Bold font weight
      fontSize: 14,            // Base font size
      h1: { fontSize: '22px' }, // H1 style
      h2: { fontSize: '16px' }, // H2 style
      h3: { fontSize: '1.5rem' }, // H3 style
      h4: { fontSize: '1.25rem' }, // H4 style
      h5: { fontSize: '1rem' }, // H5 style
      h6: { fontSize: '0.875rem' }, // H6 style
    },
    spacing: {
      unit: 5, // Spacing unit (in pixels)
    },
    borders: {
      radius: '4px', // Border radius for rounded corners
      width: '0,75px',  // Border width
      color: '#102A83', // Border color
      greenBorder:'#27AE60',
      greyBorder :'#C0C4D6'
    }
  };

  const ThemeContext = createContext<Theme | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <ThemeContext.Provider value={defaultTheme}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to access the theme
export const useTheme = () => {
  const theme = useContext(ThemeContext);
  if (!theme) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return theme;
};
  
  // export default defaultTheme;
  